<template>

    <div class="page-content">
        <div class="container-fluid">

            <Breadcrumb
                :pgTitle="$t('nav.offlineCourses')"
                :pgIcon="'bx bx-video-off'"
                :refs="refs"
                :addNew="addNew">
            </Breadcrumb>


            <DataTable
                :refs="refs"
                :colspan=10

                :hasSearchFilter=true
                :hasTimeFilter=true
                :hasDateFilter=true
                :hasStatusApproved=true
                :hasStatusFilter=true
                :hasLecturerFilter=true

                :hasHashId=true
                :hasMultiSelect=false
                :hasBulkAction=true
                :HasExport=true
                :hasShowEntries=true

                :lblSearch="$t('app.search')"

                :fields="{
                    'id': 'id',
                    'title': 'title',
                    'period': 'period',
                    'price': 'price',
                    'time': 'time',
                    'date': 'date',
                    'paid': 'paid',
                    'status': 'status'
                }"

                :hasImage=true
                :image="$t('view.course_image')"
                :image_style="'width: 40px;height: 40px'"

                :hasTitle=true
                :title="$t('view.course_title')"

                :hasPrice=true
                :price="$t('view.course_price')"

                :hasPeriod=true
                :hasDate=true
                :hasTime=true
                :hasStatus=true
                :hasActions=true
                :hasDeleteButton=true

                :actionable=true
                :sorDataTable=true

                v-on:hasAddNewPermission="handlePermissoinChange">
            </DataTable>

        </div>
    </div>

</template>

<script>
export default {
    name: 'List',
    components: {
        Breadcrumb: () => import('@/components/Breadcrumb.vue'),
        DataTable: () => import('@/components/DataTable.vue')
    },
    data(){
        return {    
            //
            addNew: false,
            refs: 'offlineCourses',
        }
    },
    watch: {
        //
    },
    mounted() {
        //
    },
    created() {
        //
    },
    methods: {
        handlePermissoinChange(event) {
            this.addNew = event;
        },
    },
}
</script>
